<template>
  <div>
    <PageMain
      ref="main"
      :disabled="disabled"
      :amzReplenishmentCode="amzReplenishmentCode"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :isVc="isVc"
      @reload="reload"
      @openEditDialog="openEditDialog"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <template #header>
        <div class="d-flex justify-content-between">
          <div class="d-flex" style="flex:1;">
            <PageHeader
              ref="header"
              @query="getData"
              @reset="resetPage"
              :isVc="isVc"
              :disabled="disabled"
              :searchTabValue="searchTabValue"
            />
            <div>
              <b-button
                size="sm"
                class="ml-2"
                variant="outline-success"
                @click="showAppendSku = true"
                v-if="!disabled && isVc != 'Y'"
              >
                {{ $l('btn_append') || '追加SKU' }}
              </b-button>
              <b-button
                size="sm"
                class="ml-2"
                variant="outline-success"
                @click="showSkuBatchEdit = true"
                v-if="!disabled"
              >
                {{ $l('INDEX.btn_batch_comfirm') || '确认补货数量' }}
              </b-button>
              <el-badge
                :value="checkedRowCount"
                :hidden="!checkedRowCount"
                class="submit-button"
                :class="{ clearable: !!checkedRowCount }"
                v-if="!disabled"
              >
                <b-button
                  size="sm"
                  class="ml-2"
                  variant="outline-success"
                  @click="submit()"
                  :disabled="!checkedRowCount"
                >
                  {{ $l('btn_submit') || '提交审核' }}
                  <i
                    class="el-icon-circle-close"
                    @click.stop="clearCheckboxRow"
                  />
                </b-button>
              </el-badge>
            </div>
          </div>
          <SearchTabs @change="searchTabChange" />
        </div>
      </template>

      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <AppendSku
      :visible.sync="showAppendSku"
      :amzReplenishmentCode="amzReplenishmentCode"
      @reload="reload"
    />

    <SkuBatchEdit
      v-if="isVc !== 'Y'"
      :visible.sync="showSkuBatchEdit"
      :amzReplenishmentCode="amzReplenishmentCode"
      @reload="reload"
    />

    <VcSkuBatchEdit
      v-if="isVc === 'Y'"
      :visible.sync="showSkuBatchEdit"
      :amzReplenishmentCode="amzReplenishmentCode"
      @reload="reload"
    />

    <SkuEditForm
      ref="editForm"
      v-if="isVc !== 'Y'"
      :visible.sync="editFormDialogOptions.visible"
      :title="editFormDialogOptions.title"
      :disabled="editFormDialogOptions.disabled"
      :amzReplenishmentDetailCode="editFormDialogOptions.code"
      @reload="reload"
    />

    <VcSkuEditForm
      ref="editForm"
      v-if="isVc === 'Y'"
      :visible.sync="editFormDialogOptions.visible"
      :title="editFormDialogOptions.title"
      :disabled="editFormDialogOptions.disabled"
      :amzReplenishmentDetailCode="editFormDialogOptions.code"
      @reload="reload"
    />
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import SkuBatchEdit from '../sku-batch-edit'
import VcSkuBatchEdit from '../vc-sku-batch-edit'
import SkuEditForm from '../sku-edit-form'
import VcSkuEditForm from '../vc-sku-edit-form'
import SearchTabs from './search-tabs'
import AppendSku from '../append-sku'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageMain,
    PageHeader,
    SkuBatchEdit,
    VcSkuBatchEdit,
    SkuEditForm,
    VcSkuEditForm,
    SearchTabs,
    AppendSku,
  },
  props: {
    disabled: { type: Boolean, default: false },
    amzReplenishmentCode: { type: String, default: '' },
    isVc: { type: String, default: '' },
  },
  data() {
    return {
      usePage: true,
      showSkuBatchEdit: false,
      searchTabValue: 'B',
      editFormDialogOptions: { visible: false, code: '' },
      checkedRows: [],
      showAppendSku: false,
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    async getData(form) {
      this.loading = true
      this.$api
        .ecomAmzReplenishmentDetailListApi({
          ...form,
          ...this.page,
          amzReplenishmentCode: this.amzReplenishmentCode,
          isSubmitQty: this.searchTabValue === 'A' ? 'N' : 'Y',
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.clearCheckboxRow()
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditDialog({ type, code = '' }) {
      const types = {
        edit: this.$l('INDEX.title_label_edit') || '编辑',
        detail: this.$l('INDEX.title_label_detail') || '详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
    searchTabChange(e) {
      this.searchTabValue = e
      setTimeout(() => {
        this.$refs.header.query()
      }, 0)
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    async submit() {
      if (!this.checkedRowCount) {
        this.$message({
          message:
            this.$l('tips_submitEmpty') || '请选择需要提交审核的补货明细',
          type: 'warning',
        })
        return
      }

      const confirm = await this.$confirm(
        this.$l('confirmTips_submit') || '是否确认提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return

      const listCode = this.checkedRows.map(
        (row) => row.amzReplenishmentDetailCode
      )
      const res = await this.$api
        .ecomAmzReplenishmentDetailSubmitApi({ listCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_submission_failed'))
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_Submitted_successfully'),
        type: 'success',
      })
      this.reload()
    },
  },
}
</script>
<style lang="scss" scoped>
.submit-button {
  .el-icon-circle-close {
    display: none;
  }
}
.submit-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
<style lang="scss" scoped>
::v-deep {
  .vxe-buttons--wrapper {
    .search-form {
      flex: 1;
      max-width: 900px;
    }
    .search-container {
      margin: 0 12px;
    }
  }
}
</style>
